import { styled as r, Box as s } from "@mui/material";
import m from "../../temp-lib/components/share/apeiron/ApeironLinkButton.js";
import c from "../../temp-lib/components/share/generic/IconText.js";
import { AnimateTime as e } from "../constants/layout.js";
import { jsx as o } from "react/jsx-runtime";
const d = r(s)`
  background-color: white;
  border-radius: 100px;
  padding: 2px;
  box-shadow: 4px 4px 10px #00000066;
  transition: filter ${e}ms;

  :hover {
    filter: brightness(1.05) saturate(1.125) drop-shadow(0px 2px 6px #319fed);

    .Custom-Link {
      .Custom-Icon-Text {
        transform: translateY(-4px);
        .Custom-Text {
          color: #f1b535;
        }
      }
    }
  }
`, l = r(m)`
  --background-color: black;
  border-radius: 100px;
  justify-content: flex-start;
  width: 100%;

  ${(t) => t.theme.breakpoints.up("res768")} {
    height: 52px;
    padding: 0px 10px 0px 4px;
  }
  ${(t) => t.theme.breakpoints.down("res768")} {
    height: 42px;
    padding: 0px 10px 0px 4px;
  }
`, u = r(c)`
  transition: transform ${e}ms;
  .Custom-Text {
    font-weight: 400;
    letter-spacing: 0.25px;
    text-align: left;
    transition: color ${e}ms;
    white-space: break-spaces;

    ${(t) => t.theme.breakpoints.up("res768")} {
      font-size: 14px;
    }
    ${(t) => t.theme.breakpoints.down("res768")} {
      font-size: 12px;
    }
  }
`, C = (t) => {
  const {
    className: n,
    icon: i,
    url: a,
    target: p,
    text: x
  } = t;
  return /* @__PURE__ */ o(s, {
    className: n,
    children: /* @__PURE__ */ o(d, {
      className: "Custom-Container",
      children: /* @__PURE__ */ o(l, {
        className: "Custom-Link",
        url: a,
        target: p,
        children: /* @__PURE__ */ o(u, {
          className: "Custom-Icon-Text",
          startSrc: i,
          text: x
        })
      })
    })
  });
};
export {
  C as default
};
//# sourceMappingURL=ApeironGotoRoundButton.js.map
